<template>
  <div
    class="modal fade colored-header colored-header-primary"
    id="mod-hide-order-stage"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body p-4">
          <h4 class="text-center">
            {{ text }}
          </h4>
        </div>
        <div
          class="modal-footer d-flex justify-content-center align-items-center"
        >
          <button class="btn btn-danger" type="button" data-dismiss="modal">
            No
          </button>
          <button
            class="btn btn-success"
            type="button"
            @click.prevent="onSubmitClick"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HideStageCaution",
  props: ["text"],

  methods: {
    onSubmitClick() {
      this.$emit("proceed");
    },
  },
};
</script>

<style>
</style>